// extracted by mini-css-extract-plugin
export var bodyContent = "styles-module--bodyContent--5ffb3";
export var cardTitles = "styles-module--cardTitles--415be";
export var left = "styles-module--left--27f57";
export var right = "styles-module--right--e5bc7";